import React, { useState, useEffect, useRef } from 'react';
import flagService from '../../services/FlagService';
const { townNamesMatch } = require('../../util/util');
import { Cookies } from 'react-cookie-consent';
import { navigate, useStaticQuery, graphql } from 'gatsby';
import { validateEmail } from '../../services/EmailService';
import { ReferralCodeCookie } from '../../data/Cookies';
import FacebookPixelEvents from '../../services/FacebookPixelEvents';
import { SendFacebookConversionsEvent } from '../../services/FacebookConversionsApiService';
import useSentryError from '../../hooks/useSentryError';
import { ContactCookie, InterestCookie } from '../../data/Cookies';
import SimplePagePopUp from '../SimplePagePopUp';
import BusinessMatchForm from '../business/BusinessMatchForm';
import { handleDate } from '../../util/util';

import Modal from '../Modal';
const RegisterInterestWrapper = ({
  selectedAddress,
  setSelectedAddress,
  landingPages,
  region,
  forceReferralCode,
  defaultSource,
  leadSource,
  showSalesFields,
  isModularBlock,
  successPath,
  isHumanHelp,
  alreadyACustomer,
  children,
  setContractDate,
  contractDate,
  followUpDate,
  defaultFormData,
  setDefaultFormData,
  sfFields,
}) => {
  const [customRIPage, setCustomRIPage] = useState(undefined);
  const [defaultReferralCode, setDefaultReferralCode] = useState();
  const [dialogShow, setDialogShow] = useState(true);
  const [animation, setAnimation] = useState(false);
  const [showMatchForm, setShowMatchForm] = useState(false);
  const [showMatchText, setShowMatchText] = useState(false);
  const [gclid, setGclid] = useState();
  const modal = useRef(null);
  const isHumanHelpWebToLead = flagService.HumanHelpWebToLead;
  const residential = selectedAddress?.residential;

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search);
      const gclidValue = params.get('gclid');
      gclidValue && setGclid(gclidValue);
    }
  }, []);

  const { datoCmsSimpleWebsitePageModel } = imageQuery();
  const switchDialog = () => {
    const dialog = modal.current;
    setDialogShow((prevState) => !prevState);
    if (dialogShow) {
      dialog.showModal();
      setAnimation('open-modal');
    } else {
      setAnimation('close-modal');
      setTimeout(() => {
        dialog.close();
      }, 200);
    }
  };

  const [sentryError, setSentryError] = useSentryError();

  useEffect(() => {
    // Executed on Mount
    let addressCookie = Cookies.get(InterestCookie);
    let defaultFormCookie = Cookies.get(ContactCookie);
    if (defaultFormCookie) {
      setDefaultFormData(JSON.parse(defaultFormCookie));
    }
    if (defaultFormData?.contractEndDate) {
      handleDate(defaultFormData.contractEndDate, setContractDate);
    }
    if (addressCookie) {
      let storedAddress = JSON.parse(atob(addressCookie));
      setSelectedAddress(storedAddress);

      if (landingPages) {
        const RISlug = getRIPageSlug(storedAddress);
        if (RISlug) navigate(`/get-lit/${RISlug}/register-interest`);

        // TODO: Improve on this. There is a plugin called Launchdarkly, which I'm not overly impressed with for what we need
        // For now, Environmental Variables will do. But it'd just be another website we need to sign up to.
        // Otherwise, we could drive this from datoCmsModel, or our own portal/API
        if (flagService.CustomRIPage) {
          const pageData = getCustomRIPage(storedAddress, landingPages);
          setCustomRIPage(pageData);
        }
      }
    } else {
      // No Cookie - Need to redirect.
      !isModularBlock && navigate('/secure-order/contact-form-page');
    }

    const referralCookie = Cookies.get(ReferralCodeCookie);
    if (referralCookie && !defaultReferralCode)
      setDefaultReferralCode(atob(referralCookie));

    // Executed On Dismount
    return () => {};
  }, []);

  // Gets the Select Box and updates the option as to whether or not they are selected or not
  // this is a sneaky way of being able to use the Checkboxes as opposed to the multibox.
  const onPreferenceUpdate = (e) => {
    let { value } = e.target;
    let selectBox = document.getElementsByName(
      sfFields.communicationPreference,
    )[0];

    for (let index = 0; index < selectBox.length; index++) {
      const element = selectBox[index];

      if (element?.value == value) {
        element.selected = element.selected ? false : true;
      }
    }
  };

  // Takes the date and reformats it - appears Salesforce does not either like the format
  // the original box provided or was not being sent over correctly.

  const getRIPageSlug = (address) => {
    let result = undefined;
    landingPages?.edges.forEach((townNode) => {
      if (
        address &&
        townNamesMatch(townNode.node.townName, address.postalTown)
      ) {
        result = townNode.node.slug;
      }
    });
    return result;
  };

  const getCustomRIPage = (address, landingPages) => {
    let customRIPage = undefined;

    if (address) {
      landingPages?.edges.forEach((edge) => {
        if (
          townNamesMatch(edge.node.townName, address.postalTown) ||
          townNamesMatch(edge.node.townName, address.addressLine2) ||
          townNamesMatch(edge.node.townName, address.addressLine3)
        ) {
          customRIPage = {
            returnURL: `${process.env.GATSBY_BASE_ADDRESS}/get-lit/success/${edge.node.slug}`,
          };

          return;
        }
      });
    }

    return customRIPage;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    for (const input of event.target) {
      if (input.name === sfFields.email) {
        if (!(await validateEmail(input.value))) {
          const anonValue = input.value ? input.value.split('@').pop() : 'null';
          const logMessage = `Failed to validate email for RI. Domain: ${anonValue}`;
          setSentryError(
            logMessage,
            undefined,
            { uprn: selectedAddress.uprn },
            'info',
          );

          input.setCustomValidity('Email is invalid');
          input.reportValidity();
          return;
        }
        break;
      }
    }

    if (!showSalesFields) {
      let facebookEventId = '';
      let firstName = '';
      let lastName = '';
      let phone = '';
      let email = '';

      for (const input of event.target) {
        switch (input.name) {
          case sfFields.firstName:
            firstName = input.value;
            break;
          case sfFields.lastName:
            lastName = input.value;
            break;
          case sfFields.phone:
            phone = input.value;
            break;
          case sfFields.email:
            email = input.value;
            break;
        }
      }

      if (typeof self !== 'undefined') {
        facebookEventId = self.crypto.randomUUID();
      }

      SendFacebookConversionsEvent({
        postcode: selectedAddress.postcode,
        eventName: 'Lead',
        city: selectedAddress.city,
        county: selectedAddress.county,
        firstName: firstName,
        lastName: lastName,
        phone: phone,
        email: email,
        eventId: facebookEventId,
        contentName: residential ? 'Register Interest' : 'Business Interest',
      });
      FacebookPixelEvents.track(
        'Lead',
        {
          currency: 'GBP',
          delivery_category: 'home_delivery',
          content_category: 'product',
          content_name: residential ? 'Register Interest' : 'Business Interest',
          email: email,
          phone_number: phone,
          click_id: facebookEventId,
        },
        facebookEventId,
      );
    }

    event.target.submit();
  };
  let returnPath = `${process.env.GATSBY_BASE_ADDRESS}/get-lit/success/`;
  if (successPath) {
    returnPath = `${process.env.GATSBY_BASE_ADDRESS}/${successPath}`;
  } else if (showSalesFields) {
    returnPath = `${process.env.GATSBY_BASE_ADDRESS}/internal/sales/register-interest/success/`;
  } else if (customRIPage) {
    returnPath = customRIPage.returnURL;
  }

  return selectedAddress ? (
    <div
      className={showSalesFields ? 'sales-form-container' : 'form-container'}
    >
      {isHumanHelp && (
        <div className="form-heading">
          <h3 className={`${!isHumanHelpWebToLead && 'form-heading-padding'}`}>
            Chat to our Sales Team right away by calling{' '}
            <a href="tel:0330 460 4610" className="White-button-underline">
              0330 460 4610
            </a>
          </h3>
          <p>or leave your details below and we will give you a call back!</p>
        </div>
      )}
      <div className="form-wrapper">
        <form
          className={`${isModularBlock ? 'form' : 'form-black'}`}
          action={sfFields.url}
          method="POST"
          onSubmit={handleSubmit}
          autoComplete={showSalesFields && 'off'}
        >
          {/* <input type="hidden" name="debug" value={1} />
          <input
            type="hidden"
            name="debugEmail"
            value="ishbel.fahey-theaker@litfibre.com"
          /> */}
          <div className="form-input-container">
            <input
              type="hidden"
              name="oid"
              value={sfFields.oid}
              defaultValue={sfFields.oid}
            />
            <input type="hidden" name="retURL" defaultValue={returnPath} />
            <input
              type="hidden"
              name={sfFields.uprn}
              defaultValue={selectedAddress?.uprn}
              value={selectedAddress?.uprn}
            />
            <input
              type="hidden"
              name={sfFields.leadSource}
              defaultValue={leadSource ?? 'website'}
              value={leadSource ?? 'website'}
            />
            <input
              type="hidden"
              name={sfFields?.leadType}
              id={sfFields?.leadType}
              value={'RI Lead'}
            />
            <input
              type="hidden"
              name={sfFields?.litLeadType}
              id={sfFields?.litLeadType}
              value={residential ? 'Residential' : 'Business'}
            />
            <input
              id={sfFields.gclid}
              name={sfFields.gclid}
              type="hidden"
              value={gclid}
            />
            <input
              type="hidden"
              name={sfFields.street}
              defaultValue={`${selectedAddress.addressLine1}${
                selectedAddress.addressLine2
                  ? `, ${selectedAddress.addressLine2}`
                  : ''
              }${
                selectedAddress.addressLine3
                  ? `, ${selectedAddress.addressLine3}`
                  : ''
              }`}
            />
            {region && (
              <input
                type="hidden"
                name={sfFields.region}
                id={sfFields.region}
                defaultValue={region}
              />
            )}
            <input
              type="hidden"
              name={sfFields.city}
              defaultValue={selectedAddress.postalTown}
            />
            <input
              type="hidden"
              name={sfFields.zip}
              defaultValue={selectedAddress.postcode}
            />
            <input
              type="hidden"
              name={sfFields.state}
              defaultValue={selectedAddress.county}
            />
            <input
              type="hidden"
              name={sfFields.country}
              defaultValue="United Kingdom"
            />
            <input
              id={sfFields.endDate}
              name={sfFields.endDate}
              value={contractDate}
              type="hidden"
            />
            <input
              id={sfFields.followUpDate}
              name={sfFields.followUpDate}
              value={followUpDate}
              type="hidden"
            />
            <input
              id={residential ? sfFields.orderable : sfFields.businessOrderable}
              name={
                residential ? sfFields.orderable : sfFields.businessOrderable
              }
              type="hidden"
              defaultValue={selectedAddress.orderable ? 'Yes' : 'No'}
            />
            <input
              type="hidden"
              name={sfFields.latitude}
              defaultValue={selectedAddress.latitude}
            />
            <input
              type="hidden"
              name={sfFields.longitude}
              defaultValue={selectedAddress.longitude}
            />
            <select
              id={sfFields.communicationPreference}
              multiple="multiple"
              name={sfFields.communicationPreference}
              title="Contact Preferences"
              hidden
            >
              <option value="Email">Email</option>
              <option value="Phone">Phone</option>
              <option value="Mail">Mail</option>
            </select>
            <input
              type="hidden"
              id={sfFields.litContactType}
              name={sfFields.litContactType}
              value={residential ? 'Residential' : 'Business'}
            />
            {!forceReferralCode && (
              <div
                className="form-input-inner"
                style={{ position: 'absolute' }}
              >
                <label type="hidden" style={{ opacity: 0 }}>
                  Referral Code
                </label>
                <input
                  type="hidden"
                  id={sfFields.referralCode}
                  name={sfFields.referralCode}
                  defaultValue={defaultReferralCode}
                  maxLength={6}
                />
              </div>
            )}
            {forceReferralCode && (
              <input
                type="hidden"
                id={sfFields.referralCode}
                name={sfFields.referralCode}
                defaultValue={forceReferralCode}
              />
            )}{' '}
            <div className="form-input-inner columm-1">
              <label>
                First Name<span>*</span>
              </label>
              <input
                type="text"
                placeholder="First Name"
                defaultValue={defaultFormData?.firstName}
                name={sfFields.firstName}
                role={showSalesFields && 'presentation'}
                required
              />
            </div>
            <div className="form-input-inner column-3">
              <label>
                Last Name<span>*</span>
              </label>
              <input
                type="text"
                placeholder="Last Name"
                defaultValue={defaultFormData?.lastName}
                name={sfFields.lastName}
                role={showSalesFields && 'presentation'}
                required
              />
            </div>
            {children}
            <div className="column-1">
              <p className="form-contact-preferences">Contact Preferences</p>
              <div className="form-contact-flex-container">
                <div
                  className={`${
                    isModularBlock
                      ? 'form-checkbox-container'
                      : 'form-checkbox-container-white'
                  }`}
                >
                  <input
                    className={`${
                      isModularBlock ? 'checkbox' : 'checkbox-white'
                    }`}
                    type="checkbox"
                    value="Email"
                    onClick={(e) => onPreferenceUpdate(e)}
                  />
                  <p>E-mail</p>
                </div>
                <div
                  className={`${
                    isModularBlock
                      ? 'form-checkbox-container'
                      : 'form-checkbox-container-white'
                  }`}
                >
                  <input
                    className={`${
                      isModularBlock ? 'checkbox' : 'checkbox-white'
                    }`}
                    type="checkbox"
                    value="Phone"
                    onClick={(e) => onPreferenceUpdate(e)}
                  />
                  <p>Phone</p>
                </div>
                <div
                  className={`${
                    isModularBlock
                      ? 'form-checkbox-container'
                      : 'form-checkbox-container-white'
                  }`}
                >
                  <input
                    className={`${
                      isModularBlock ? 'checkbox' : 'checkbox-white'
                    }`}
                    type="checkbox"
                    value="Mail"
                    onClick={(e) => onPreferenceUpdate(e)}
                  />
                  <p>Mail</p>
                </div>
              </div>
            </div>
            <div className="form-checkbox-container column-span">
              <div
                className={`${
                  isModularBlock
                    ? 'form-checkbox-container'
                    : 'form-checkbox-container-white'
                }`}
              >
                <input
                  className={`${
                    isModularBlock ? 'checkbox' : 'checkbox-white'
                  }`}
                  type="checkbox"
                  required
                  onChange={(e) => {
                    !residential && setShowMatchText(e.target.checked);
                  }}
                  defaultChecked={defaultFormData?.Marketing}
                />
                <p>
                  By ticking the box I consent to Lit Fibre processing and
                  storing this information in accordance with its{' '}
                  <button onClick={switchDialog} type="button">
                    Privacy Policy
                  </button>{' '}
                  and using these details to send me information about Lit
                  Fibre's services. I understand that I may change my mind and
                  unsubscribe at any time. Your contact details will be used for
                  keeping them up to date with our progress and we will not be
                  shared with third parties.{' '}
                </p>
                <Modal
                  animation={animation}
                  dialogShow={dialogShow}
                  modal={modal}
                  switchDialog={switchDialog}
                >
                  <div className="modal-simple-website">
                    <SimplePagePopUp
                      simpleModularContent={
                        datoCmsSimpleWebsitePageModel.simpleModularContent
                      }
                      title={datoCmsSimpleWebsitePageModel.title}
                      slug={datoCmsSimpleWebsitePageModel.slug}
                    />
                  </div>
                </Modal>
              </div>
            </div>
          </div>
          {!showMatchText && (
            <div className="form-button-container">
              <button className="square-button-yellow">Register</button>
            </div>
          )}
          {showMatchText && !residential && (
            <BusinessMatchForm
              isModularBlock={isModularBlock}
              sfFields={sfFields}
              showMatchText={showMatchText}
              setShowMatchText={setShowMatchText}
              showMatchForm={showMatchForm}
              setShowMatchForm={setShowMatchForm}
            />
          )}
        </form>
      </div>
    </div>
  ) : null;
};

export default RegisterInterestWrapper;
const imageQuery = () =>
  useStaticQuery(graphql`
    {
      datoCmsSimpleWebsitePageModel(slug: { eq: "legal/privacy-policy" }) {
        title
        slug
        simpleModularContent {
          ...ModularSimpleHero
          ...ModularParagraph
          ...ModularSimpleContent
        }
      }
    }
  `);
